import {
    ORDERS_LIST_REQUEST,
    ORDERS_LIST_SUCCESS,
    ORDERS_LIST_FAILURE,
    GET_ORDER_ITEM_LIST_REQUEST,
    GET_ORDER_ITEM_LIST_SUCCESS,
    GET_ORDER_ITEM_LIST_FAILURE,
    GET_ORDER_INFO_REQUEST,
    GET_ORDER_INFO_SUCCESS,
    GET_ORDER_INFO_FAILURE,
    GET_ORDER_ADDRESS_REQUEST,
    GET_ORDER_ADDRESS_SUCCESS,
    GET_ORDER_ADDRESS_FAILURE,
    LIST_COUPONS_REQUEST,
    LIST_COUPONS_SUCCESS,
    LIST_COUPONS_FAILURE,
    GET_COUPON_PROCESS_REQUEST,
    GET_COUPON_PROCESS_SUCCESS,
    GET_COUPON_PROCESS_FAILURE,
    UPDATE_ORDER_REQUEST,
    UPDATE_ORDER_SUCCESS,
    UPDATE_ORDER_FAILURE,
    ORDER_CREDIT_CARD_PAYMENT_REQUEST,
    ORDER_CREDIT_CARD_PAYMENT_SUCCESS,
    ORDER_CREDIT_CARD_PAYMENT_FAILURE,
    UPDATE_SHIPPING_CART_REQUEST,
    UPDATE_SHIPPING_CART_SUCCESS,
    UPDATE_SHIPPING_CART_FAILURE,
    GET_SHIPPING_CART_REQUEST,
    GET_SHIPPING_CART_SUCCESS,
    GET_SHIPPING_CART_FAILURE,
    CREATE_SHIPPING_ORDER_REQUEST,
    CREATE_SHIPPING_ORDER_SUCCESS,
    CREATE_SHIPPING_ORDER_FAILURE,
    GET_FEE_REQUEST,
    GET_FEE_SUCCESS,
    GET_FEE_FAILURE,
    INBOUND_ORDER_LIST_REQUEST,
    INBOUND_ORDER_LIST_SUCCESS,
    INBOUND_ORDER_LIST_FAILURE,
    ORDER_CREDIT_CART_PAYMENT_REQUEST,
    ORDER_CREDIT_CART_PAYMENT_SUCCESS,
    ORDER_CREDIT_CART_PAYMENT_FAILURE,
    SAVE_SHIPPING_DATA,
    CLEAN_SHIPPING_DATA,
    CLEAN_ORDER_CREDIT_CART_PAYMENT_RESULT,
    CHANG_ROUTE,
    CLEAN_ACTION,
} from '../actions/orders'
import { fromJS } from 'immutable'

const initState = {
    isLoading: false,
    orderList: {
        list: [],
        pagination: {
            totalCount: 0
        }
    },
    shippingCart: fromJS({
        list: [],
        pagination: {}
    }),
    wineIdList: fromJS([]),
    getShippingCartSucc: false,
    
    createShippingOrderSucc: false,
    createShippingOrderFail: false,
    errorCode: 0,
    succShippingOrder: fromJS({}),
    shippingOrderData: fromJS({}),

    coupons: fromJS({
        list: [],
        pagination: {
            totalCount: 0
        },
    }),
    historyAddress: fromJS([]),
    serviceFee: fromJS({}),
    shippingFee: fromJS({}),
    orderInfo: fromJS({}),

    isOrderItemListLoading: false,
    orderItemList: fromJS({
        list: [],
        pagination: {
            totalCount: 0
        },
    }),

    orderCreditCardPaymentSucc: false,
    orderCreditCardPaymentFail: false,

    couponProcessList: fromJS({}),

    inboundOrderList: fromJS({
        list: [],
        pagination: {
            totalCount: 0
        }
    }),

    succUpdatedOrder: fromJS({}),
    updateOrderSucc: false,
    updateOrderFail: false,

    routeParam: fromJS({}),
}

export default (state = initState, action) => {
    switch (action.type) {
        case CHANG_ROUTE: 
            return {
                ...state,
                routeParam: fromJS(action.payload)
            }
        case CLEAN_ACTION: {
            const { cleanedKeys } = action
            const updater = {}
            cleanedKeys.forEach(keyName => {
                updater[keyName] = initState[keyName]
            })
            return {
                ...state,
                ...updater,
            }
        }
        case ORDERS_LIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case ORDERS_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                orderList: { ...action.payload }
            }
        }
        case ORDERS_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case INBOUND_ORDER_LIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case INBOUND_ORDER_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                inboundOrderList: fromJS(action.payload)
            }
        }
        case INBOUND_ORDER_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case GET_ORDER_ITEM_LIST_REQUEST:
            return {
                ...state,
                isOrderItemListLoading: true
            }
        case GET_ORDER_ITEM_LIST_SUCCESS: {
            let orderList = { ...state.orderList }
            let order = orderList.list.filter(order => order.id === action.payload.orderId)
            if (order) {
                order.itemList = { ...action.payload.orderItemList }
            }
            return {
                ...state,
                isOrderItemListLoading: false,
                orderList: orderList,
                orderItemList: fromJS(action.payload.orderItemList),
            }
        }
        case GET_ORDER_ITEM_LIST_FAILURE: {
            return {
                ...state,
                isOrderItemListLoading: false
            }
        }
        case GET_ORDER_INFO_REQUEST:
            return {
                ...state,
                isLoading: true,
                orderInfo: initState.orderInfo
            }
        case GET_ORDER_INFO_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                orderInfo: fromJS(action.payload)
            }
        }
        case GET_ORDER_INFO_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case GET_ORDER_ADDRESS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_ORDER_ADDRESS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                historyAddress: fromJS([...action.payload])
            }
        }
        case GET_ORDER_ADDRESS_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case LIST_COUPONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                coupons: initState.coupons,
            }
        case LIST_COUPONS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                coupons: fromJS(action.payload)
            }
        }
        case LIST_COUPONS_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case GET_COUPON_PROCESS_REQUEST:
            return {
                ...state,
            }
        case GET_COUPON_PROCESS_SUCCESS: {
            let couponProcessList = state.couponProcessList
            action.payload.list.forEach(item => {
                couponProcessList = couponProcessList.set(item.storageCouponId, fromJS(item))
            });
            return {
                ...state,
                couponProcessList,
            }
        }
        case GET_COUPON_PROCESS_FAILURE: {
            return {
                ...state,
            }
        }
        case UPDATE_ORDER_REQUEST:
            return {
                ...state,
                isLoading: true,
                updateOrderSucc: false,
                updateOrderFail: false,
            }
        case UPDATE_ORDER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                updateOrderSucc: true,
                succUpdatedOrder: fromJS(action.payload)
            }
        }
        case UPDATE_ORDER_FAILURE: {
            return {
                ...state,
                isLoading: false,
                updateOrderFail: true,
            }
        }
        case UPDATE_SHIPPING_CART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_SHIPPING_CART_SUCCESS: {
            return {
                ...state,
                isLoading: false
            }
        }
        case UPDATE_SHIPPING_CART_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case GET_SHIPPING_CART_REQUEST:
            return {
                ...state,
                isLoading: true,
                getShippingCartSucc: false
            }
        case GET_SHIPPING_CART_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                getShippingCartSucc: true,
                shippingCart: fromJS(action.payload),
            }
        }
        case GET_SHIPPING_CART_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case CLEAN_SHIPPING_DATA: {
            return {
                ...state,
                shippingOrderData: initState.shippingOrderData
            }
        }
        case SAVE_SHIPPING_DATA: {
            return {
                ...state,
                shippingOrderData: fromJS(action.payload),
            }
        }
        case CREATE_SHIPPING_ORDER_REQUEST:
            return {
                ...state,
                isLoading: true,
                createShippingOrderSucc: false,
                createShippingOrderFail: false,
                succShippingOrder: initState.succShippingOrder,
            }
        case CREATE_SHIPPING_ORDER_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                createShippingOrderSucc: true,
                succShippingOrder: fromJS(action.payload),
            }
        }
        case CREATE_SHIPPING_ORDER_FAILURE: {
            return {
                ...state,
                isLoading: false,
                createShippingOrderFail: true,
                errorCode: action.payload.errorCode,
            }
        }
        case GET_FEE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_FEE_SUCCESS: {
            let serviceFee = {}, shippingFee = {};
            action.payload.serviceFee.forEach(item => {
                serviceFee[item.shippingUrgency] = item.fee
            })
            action.payload.shippingFee.forEach(item => {
                shippingFee[item.totalBottle] = item.fee
            })
            return {
                ...state,
                isLoading: false,
                serviceFee: fromJS(serviceFee),
                shippingFee: fromJS(shippingFee)
            }
        }
        case GET_FEE_FAILURE: {
            return {
                ...state,
                isLoading: false
            }
        }
        case ORDER_CREDIT_CART_PAYMENT_REQUEST: {
            return {
                ...state,
                isLoading: true,
                orderCreditCardPaymentSucc: false,
                orderCreditCardPaymentFail: false,
            }
        }
        case ORDER_CREDIT_CART_PAYMENT_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                orderCreditCardPaymentSucc: true,
            }
        }
        case ORDER_CREDIT_CART_PAYMENT_FAILURE: {
            return {
                ...state,
                isLoading: false,
                orderCreditCardPaymentFail: true,
            }
        }
        case CLEAN_ORDER_CREDIT_CART_PAYMENT_RESULT: {
            return {
                ...state,
                orderCreditCardPaymentSucc: false,
                orderCreditCardPaymentFail: false,
                createShippingOrderSucc: false,
                createShippingOrderFail: false,
                errorCode: initState.errorCode,
            }
        }
        default:
            return state
    }
}